<template>
  <section class="survey-message-section">
    <img class="survey-message-section__logo mb-9 mt-4" :src="logoUrl" v-if="logoUrl && logoUrl.length > 0" />
    <div class="survey-message-section__heading">
      <p v-if="preTitle">{{ preTitle }}</p>
      <h1 :class="`${isTheRiseFrameworkSurvey ? 'mainColor--text' : ''}`" v-if="title">{{ title }}</h1>
    </div>
    <p v-if="description" class="survey-message-section__description">{{ description }}</p>
    <slot></slot>
    <v-btn
      v-if="showButton"
      :disabled="isLoading"
      :loading="isLoading"
      @click="onClickSubmit"
      rounded
      :color="isTheRiseFrameworkSurvey ? 'mainColor' : 'primary'"
      elevation="0"
      :class="`${isTheRiseFrameworkSurvey ? 'bhWhite--text' : ''} no-print`"
    >
      {{ buttonText }}
    </v-btn>
  </section>
</template>

<script>
export default {
  name: 'SurveyMessageSection',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    logoUrl: {
      type: String,
      default: '',
    },
    preTitle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: ``,
    },
    description: {
      type: String,
      default: ''
    },
    showButton: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: 'Get Started!'
    },
    isTheRiseFrameworkSurvey: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
    onClickSubmit() {
      this.$emit('handle-submit')
    }
  },
}
</script>

<style lang="scss">
@import '@/styles/variables';

.survey-message-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 710px;
  width: 100%;
  margin: 0 auto;

  &__heading,
  &__description {
    white-space: pre-line;
  }

  &__logo {
    width: 80%;
    max-width: 300px;
  }

  &__heading,
  &__description {
    padding-bottom: $gutter * 1.5;
  }
}
</style>
